jQuery(function($){
  $('.js-advice-category').on('click', function(){
    var category = $(this).data('category');
    $('.js-advices').data('category', category);
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        'action': 'get_advices_by_category',
        'category': category,
      }
    }).done(function(response){
      var res = JSON.parse(response);
      $('.advices-listing-grid .sv-g').html(res.content);
      if (res.lastpage) {
        $('.js-advices').css('display', 'none');
      }
    });
  });
  // $('.js-advices').on('click', function(){
  //   var category = $(this).data('category');
  //   var page = $(this).data('page');
  //   $(this).data('page', page + 1);
  //   $.ajax({
  //     url: ajaxurl,
  //     type: "POST",
  //     data: {
  //       'action': 'get_advices',
  //       'category': category,
  //       'page': page
  //     }
  //   }).done(function(response){
  //     var res = JSON.parse(response);
  //     $('.advices-listing-grid .sv-g').append(res.content);
  //   });
  // });
});
